<template>
  <div>
    <br />
    <h1 class="titles mt-3">
      <span class="c-shadow-sm" style="color: #8b8c8c; padding: 15px"
        >Coordinación General de Simplificación y Digitalización
      </span>
    </h1>

    <b-row align-h="center">
      <b-col cols="11" md="10" lg="8" xl="6" class="mt-3 mb-3">
        <p></p>
        <h5>
          <b>
            ¿Qué es la Coordinación General de Simplificación y
            Digitalización?</b
          >
        </h5>
        <p></p>
        <p></p>
        Es la instancia responsable de coordinar, implementar y supervisar en
        Teotihuacán las políticas, estrategias y modelos nacionales de
        simplificación administrativa y transformación digital previstos en la
        Ley Nacional para Eliminar Trámites Burocráticos.
        <p></p>
        Su función es garantizar que los trámites y servicios públicos sean
        claros, ágiles, accesibles y digitales, reduciendo cargas
        administrativas y costos burocráticos, promoviendo la interoperabilidad
        entre instituciones y fortaleciendo la confianza ciudadana mediante
        procesos eficientes y transparentes.
        <p></p>

        <b-row align-h="center">
          <b-col cols="11" md="10" lg="8" xl="6" class="mt-3 mb-3">
            <b-button
              size="lg"
              href="https://teotihuacan.gob.mx/files/coordinaciongeneral/LNETB.pdf"
              target="_blank"
              rel="noopener"
              block
            >
              Ley Nacional para Eliminar Trámites Burocráticos</b-button
            >
          </b-col>
        </b-row>

        <b-row align-h="center">
          <b-col cols="11" md="10" lg="8" xl="6" class="mt-5 mb-5">
            <b-tabs content-class="mt-3" fill>
              <b-tab>
                <template #title>
                  <h6><b-icon icon="list-check" /> <b>Cédulas REMTyS 2026</b></h6>
                </template>
                <b-row>
                  <!--
                  <b-col cols="12" class="mt-4 mb-3">
                    <h3 class="titles">
                      <span style="color: #8b8c8c"
                        ><b-icon icon="list-check" /> Registro Municipal de
                        Trámites y Servicios</span
                      >
                    </h3>
                  </b-col>
                  -->
                  <b-col class="mt-3 mb-4">
                    <b-row>
                      <b-col
                        cols="12"
                        v-for="(area, i) in this.remtys"
                        :key="i"
                      >
                        <b-card no-body class="mb-1">
                          <b-card-header
                            header-tag="header"
                            class="p-1"
                            role="tab"
                          >
                            <b-button
                              block
                              v-b-toggle="'accordion-' + i"
                              style="width: 100%; text-align: left"
                              ><b-icon icon="files" />
                              {{ area.nombre }}</b-button
                            >
                          </b-card-header>
                          <b-collapse
                            :id="'accordion-' + i"
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-row
                              align="left"
                              v-for="(archivo, i) in area.archivos"
                              :key="i"
                            >
                              <b-col style="margin: 20px">
                                <a :href="archivo.link" target="blank">
                                  <b-icon icon="file-text" font-scale="3" />
                                </a>
                                <h6>{{ archivo.nombre }}</h6>
                              </b-col>
                            </b-row>
                          </b-collapse>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  components: {},
  mounted: function () {
    var host = location.protocol + "//" + location.host;
    axios({
      method: "get",
      url: host + "/files/gobierno.json",
    })
      .then((res) => {
        this.resources = res.data;
      })
      .catch((err) => {
        alert(err);
      });
  },
  computed: {},
  data() {
    return {
      resources: null,
      remtys:[
        {nombre:"Dirección de Desarrollo Urbano", archivos:[{nombre:"Cedulas", link:"https://teotihuacan.gob.mx/files/coordinaciongeneral/CedulasRemtys2026/DireccionDesarrolloUrbano/cedulas%20REMTyS%202026%20Direccion%20de%20Desarrollo%20Urbano.pdf"}]},
      ],
    };
  },
};
</script>